import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "s20" }
const _hoisted_2 = { class: "widget shadow-100 pb-2" }
const _hoisted_3 = { class: "table separator skin1 selection" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "selection-item" }
const _hoisted_7 = ["for"]
const _hoisted_8 = ["id", "checked"]
const _hoisted_9 = { class: "flex-right" }

import { ref, reactive, onMounted } from 'vue';
    import axios from 'axios';
    import MarketAttributsFormModal from './MarketAttributsFormModal.vue';
import ConfirmationModal from '@/components/ConfirmationModal.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MarketAttributsListModal',
  props: {},
  setup(__props, { expose: __expose }) {

    // @ts-expect-error raison: lib externe mal typée
    const props = __props;
    const isModalOpen = ref(false);
    let promise: Promise<any>;
    let resolvePromise: any;
    let rejectPromise: any;
    const errorMessage = ref('');
    const loading = ref(false);
    const itemsList = ref([] as any[]);
    const formModalRef = ref<InstanceType<typeof MarketAttributsFormModal> | null>(null);
    const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);
    const selectedItem = ref(null as any);

    async function doListItems() {
        try {
            loading.value = true;
            errorMessage.value = '';
            const httpResponse = await axios.get(`/backoffice/market-attributs/list`);
            itemsList.value = httpResponse.data;
        } catch(error: any) {
            errorMessage.value = error.message;
        } finally {
            loading.value = false;
        }
    }

    async function open() {
        promise = new Promise((resolve, reject) => {
            resolvePromise = resolve;
            rejectPromise = reject;
        });
        isModalOpen.value = true;
        selectedItem.value = null;
        doListItems();
        return await promise;
    }

    function onClose() {
        resolvePromise(null);
        isModalOpen.value = false;
    }

    function onConfirm() {
        if (!selectedItem.value) { return; }
        resolvePromise(selectedItem.value);
        isModalOpen.value = false;
    }

    function onReject() {
        resolvePromise(null);
        isModalOpen.value = false;
    }

    async function doDeleteItem(item: any) {
        const confirmation = await confirmationModalRef.value?.open("Attributs Market", "Voulez-vous vraiment supprimer l'élément sélectionné ?");
        if (confirmation) {
            try {
                loading.value = true;
                errorMessage.value = '';
                await axios.post(`/backoffice/market-attributs/destroy/${item.guid}`, {});
                const index = itemsList.value.findIndex(i => i.guid == item.guid);
                if (index > -1) {
                    const itemsListCloned = itemsList.value;
                    itemsListCloned.splice(index, 1);
                    itemsList.value = itemsListCloned;
                }
            } catch(error: any) {
                errorMessage.value = error.message;
            } finally {
                loading.value = false;
            }
        }
    }

    async function openFormModal(item?: any) {
        const result = await formModalRef.value?.open(item);
        if (result) { doListItems(); }
    }

    function onItemSelected(item: any) {
        selectedItem.value = item;
    }

    __expose({ open });

return (_ctx: any,_cache: any) => {
  const _component_custom_button = _resolveComponent("custom-button")!
  const _component_custom_modal = _resolveComponent("custom-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_custom_modal, {
      show: isModalOpen.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((isModalOpen).value = $event)),
      onClosed: onClose,
      classesNames: 'modal-lg'
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", { style: {"flex":"1","display":"flex","flex-direction":"row","justify-content":"space-between"} }, [
          _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "font-semibold" }, "Attributs", -1)),
          _createElementVNode("button", {
            class: "btn-ultra white2 tips",
            style: {"border":"none","background":"none","font-size":"1.2rem"},
            onClick: openFormModal
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("div", { class: "btn-show" }, [
              _createElementVNode("img", {
                src: "/icons/icon-add.svg",
                class: "btn-icon",
                alt: ""
              }),
              _createElementVNode("span", null, "Ajouter")
            ], -1)
          ]))])
        ])
      ]),
      footer: _withCtx(() => [
        (selectedItem.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              id: "btn-confirmation-confirm",
              class: "btn-ultra white2",
              style: {"justify-content":"center"},
              onClick: onConfirm
            }, "Valider"))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          id: "btn-confirmation-reject",
          class: "btn-ultra white2",
          style: {"justify-content":"center"},
          onClick: onReject
        }, "Annuler")
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("section", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", null, [
                _createElementVNode("table", _hoisted_3, [
                  _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th"),
                      _createElementVNode("th", null, [
                        _createElementVNode("img", {
                          src: "/icons/icon-filter-up.svg",
                          class: "size-xxs mt--1",
                          alt: ""
                        }),
                        _createTextVNode(" Libellé")
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("img", {
                          src: "/icons/icon-filter-up.svg",
                          class: "size-xxs mt--1",
                          alt: ""
                        }),
                        _createTextVNode(" Enumérations")
                      ]),
                      _createElementVNode("th")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (itemsList.value.length == 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [...(_cache[3] || (_cache[3] = [
                          _createElementVNode("td", { colspan: "4" }, [
                            _createElementVNode("div", { class: "text-center text-grey-700" }, "Aucun élément trouvé")
                          ], -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (itemsList.value.length > 0)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(itemsList.value, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: 'item_' + index,
                            class: _normalizeClass(["text-grey-700 over-effect over-effect-scale", {'active': selectedItem.value?.guid == item.guid }]),
                            onClick: ($event: any) => (onItemSelected(item))
                          }, [
                            _createElementVNode("td", _hoisted_6, [
                              _createElementVNode("label", {
                                class: "btn-circle",
                                for: 'item_' + index
                              }, [
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  name: "selection[]",
                                  id: 'item_' + index,
                                  checked: selectedItem.value?.guid == item.guid
                                }, null, 8, _hoisted_8)
                              ], 8, _hoisted_7)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("h6", null, _toDisplayString(item.nom), 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("h6", null, _toDisplayString(item.valeurs.join(', ')), 1)
                            ]),
                            _createElementVNode("td", _hoisted_9, [
                              _createVNode(_component_custom_button, {
                                classesList: 'btn',
                                onClick: ($event: any) => (openFormModal(item))
                              }, {
                                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                  _createElementVNode("img", {
                                    src: "/icons/icon-edit.svg",
                                    class: "btn-icon",
                                    alt: ""
                                  }, null, -1),
                                  _createElementVNode("span", null, "Editer", -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_custom_button, {
                                classesList: 'btn-ultra white2 tips',
                                onClick: ($event: any) => (doDeleteItem(item))
                              }, {
                                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                  _createElementVNode("img", {
                                    src: "/icons/icon-delete.svg",
                                    class: "btn-icon",
                                    alt: ""
                                  }, null, -1),
                                  _createElementVNode("span", null, "Supprimer", -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"])
                            ])
                          ], 10, _hoisted_5))
                        }), 128))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1))
            ])
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1))
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(MarketAttributsFormModal, {
      ref_key: "formModalRef",
      ref: formModalRef
    }, null, 512),
    _createVNode(ConfirmationModal, {
      ref_key: "confirmationModalRef",
      ref: confirmationModalRef
    }, null, 512)
  ], 64))
}
}

})